import * as React from 'react';
import { House16, ArrowOut16 } from '@cian/ui-kit';
import { Link } from '../Link';
import * as styles from './NearbyNewbuildingsLink.css';

export interface INearbyNewbuildingsLinkProps {
  url: string;
  onClick(): void;
}

export const NearbyNewbuildingsLink: React.StatelessComponent<INearbyNewbuildingsLinkProps> = (
  props: INearbyNewbuildingsLinkProps,
) => {
  const { url, onClick } = props;

  return (
    <Link url={url} target="blank" linkStyle={styles['link']} onClick={onClick}>
      <div className={styles['logo']}>
        <House16 color={'primary_100'} />
      </div>
      <span className={styles['label']}>Другие ЖК рядом</span>
      <ArrowOut16 color={'primary_100'} />
    </Link>
  );
};
